/* Signup recognition is a convenience, never checkout eligibility. Contact handoff is tab-scoped and expires after 30 minutes. */
(() => {
  'use strict';
  const copy = JSON.parse(document.getElementById('sitr-copy-config')?.textContent || '{}');
  const localeRoot = window.Shopify?.routes?.root || '/';

  const signedKey = 'sitr-ha:signed-up:v1';
  const receiptKey = 'sitr-ha:signup-receipt:v2';
  const contactKey = 'sitr-ha:checkout-contact:v1';
  const offerEnd = Date.parse('2026-10-07T20:59:59Z');
  const launchAt = Date.parse('2026-10-01T00:00:00+03:00');
  const read = key => { try { return JSON.parse(sessionStorage.getItem(key)); } catch (_) { return null; } };
  const now = Date.now();
  const receipt = read(receiptKey);
  if (receipt && typeof receipt.id === 'string' && now >= receipt.created && now - receipt.created < 1800000) {
    try { sessionStorage.setItem(signedKey, JSON.stringify({created:receipt.created})); } catch (_) {}
  }
  const signed = read(signedKey);
  const knownBuyer = Number(document.querySelector('[data-sitr-growth]')?.dataset.orders || 0) > 0;
  const recognised = !knownBuyer && signed && Number.isFinite(signed.created) && now >= signed.created && now - signed.created < 86400000 && now < offerEnd;
  if (recognised) {
    document.querySelectorAll('a[href="#set-signup"],a[href="/#sitr-first-look"],.sitr-home__hero-action a[href="#sitr-first-look"]').forEach(link => {
      if (link.matches('.sitr-order__signup-link')) { link.hidden = true; return; }
      link.href = localeRoot + 'pages/sitr-set#set-purchase';
      link.textContent = copy.continue_set;
    });
    document.querySelectorAll('.sitr-order__offer-note').forEach(el => { el.textContent = copy.signup_conditions; });
    document.querySelectorAll('#set-signup,#sitr-first-look').forEach(section => {
      const form = section.querySelector('form[action*="/contact"]');
      if (!form || form.querySelector('[data-sitr-signup-confirmed]')) return;
      const intro = section.querySelector(':scope > div');
      const originalTitle = intro?.querySelector('h2')?.textContent;
      if (intro && !intro.contains(form)) {
        const title = intro.querySelector('h2'); if (title) title.textContent = copy.thanks_confirmed;
        const paragraphs = intro.querySelectorAll('p');
        paragraphs.forEach((p, i) => { if (i > 0) p.hidden = true; });
      }
      const box = document.createElement('div'); box.className = 'sitr-signup-ready';
      const heading = document.createElement('h3'); heading.textContent = copy.thanks_title;
      const text = document.createElement('p'); text.textContent = copy.signup_conditions;
      const link = document.createElement('a'); link.href = localeRoot + 'pages/sitr-set#set-purchase'; link.textContent = copy.continue_set; link.className = 'sitr-ready-cta';
      const change = document.createElement('button'); change.type = 'button'; change.textContent = copy.use_other_email;
      change.addEventListener('click', () => {
        form.hidden = false; box.hidden = true;
        try { sessionStorage.removeItem(signedKey); sessionStorage.removeItem(receiptKey); sessionStorage.removeItem(contactKey); } catch (_) {}
        document.querySelectorAll('.sitr-order__offer-note').forEach(el => { el.textContent = copy.offer_note; });
        document.querySelectorAll('.sitr-order__signup-link').forEach(el => { el.hidden = false; });
        if (intro && !intro.contains(form)) {
          const title = intro.querySelector('h2'); if (title) title.textContent = originalTitle;
          intro.querySelectorAll('p').forEach(p => { p.hidden = false; });
        }
        form.querySelector('[name="contact[email]"]')?.focus();
      });
      box.append(heading,text,link,change); form.before(box); form.hidden = true;
    });
  }
  function checkoutURL() {
    const contact = read(contactKey);
    if (!contact) return null;
    if (!contact.confirmed || !Number.isFinite(contact.created) || Date.now() < contact.created || Date.now() - contact.created >= 1800000) {
      try { sessionStorage.removeItem(contactKey); } catch (_) {}
      return null;
    }
    if (typeof contact.email !== 'string' || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(contact.email)) return null;
    // Preserve the existing native cart and its bundle components; no cart rebuild.
    const root = window.Shopify?.routes?.root || '/';
    const url = new URL(root + 'cart/checkout', location.origin);
    url.searchParams.set('checkout[email]', contact.email);
    if (typeof contact.phone === 'string' && /^\+[1-9]\d{6,14}$/.test(contact.phone)) url.searchParams.set('checkout[shipping_address][phone]', contact.phone);
    return url.href;
  }
  document.addEventListener('submit', event => {
    if (event.submitter?.name !== 'checkout') return;
    const url = checkoutURL(); if (!url) return;
    event.preventDefault(); event.stopImmediatePropagation();
    try { sessionStorage.removeItem(contactKey); } catch (_) {}
    location.assign(url);
  }, true);
  document.addEventListener('click', event => {
    const link = event.target.closest('a[href]');
    if (!link || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || event.button !== 0) return;
    const destination = new URL(link.href, location.origin);
    if (destination.origin !== location.origin || !/\/(cart\/)?checkout\/?$/.test(destination.pathname)) return;
    const url = checkoutURL(); if (!url) return;
    event.preventDefault(); event.stopImmediatePropagation();
    try { sessionStorage.removeItem(contactKey); } catch (_) {}
    location.assign(url);
  }, true);
  // Delete stale contact information even if the visitor does not press checkout.
  checkoutURL();
  // Recheck the fixed deadline after suspended tabs and back/forward restores.
  // The separate launch timer stops on 1 October, before this offer expires.
  let offerTimer;
  function updateOfferExpiry() {
    clearTimeout(offerTimer);
    const remaining = offerEnd - Date.now();
    if (remaining > 0) {
      offerTimer = setTimeout(updateOfferExpiry, Math.min(remaining, 2147483647));
      return;
    }
    const offers = [...document.querySelectorAll('[data-sitr-offer]')];
    const moveFocus = offers.some(el => el.contains(document.activeElement));
    offers.forEach(el => { el.hidden = true; });
    document.querySelectorAll('[data-sitr-post-offer]').forEach(el => { el.hidden = false; });
    if (moveFocus) {
      const target = document.querySelector('[data-order-form] [data-order-colour]:checked')
        || document.querySelector('#sitr-first-look .sitr-editorial__button')
        || document.querySelector('button[name="checkout"]')
        || document.querySelector('.sitr-thanks__cta');
      target?.focus();
    }
  }
  document.addEventListener('submit', event => {
    if (Date.now() < offerEnd || !event.target.closest('[data-sitr-offer]')) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    updateOfferExpiry();
  }, true);
  document.addEventListener('visibilitychange', () => { if (!document.hidden) updateOfferExpiry(); });
  window.addEventListener('pageshow', updateOfferExpiry);
  document.addEventListener('shopify:section:load', updateOfferExpiry);
  updateOfferExpiry();
})();
